"use client";
import { RouteError } from "@/components/RouteError";

export default function BrowseError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <RouteError
      error={error}
      reset={reset}
      label="BROWSE ERROR"
      backHref="/"
      backLabel="Go Home"
    />
  );
}
